import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ValidatedAddressInfo} from '../../model/validated-address-info';
import {OrganizationAddress} from '../../organization/organization-address';
import {AddressResolution} from '../../model/address-resolution';

import {MatButton} from '@angular/material/button';

@Component({
    selector: 'app-address-alternative-dialog',
    templateUrl: './address-alternative-dialog.component.html',
    styleUrls: ['./address-alternative-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButton]
})
export class AddressAlternativeDialogComponent implements OnInit {
  private readonly dialogRef = inject<MatDialogRef<AddressAlternativeDialogComponent>>(MatDialogRef);
  private readonly data = inject(MAT_DIALOG_DATA);


  validatedAddress: ValidatedAddressInfo | undefined;
  enteredAddress: OrganizationAddress;
  addressResolution: AddressResolution;
  noSuggestionMessage: string | undefined;
  addressValidationErrors: string | undefined;

  constructor() {
    const data = this.data;

    this.validatedAddress = data.validatedAddress;
    this.addressResolution = data.resolution;
    this.enteredAddress = data.enteredAddress;
  }

  ngOnInit(): void {
    if (!this.validatedAddress) {
      this.noSuggestionMessage = 'The entered address is not valid for the reasons listed below and no alternatives could be found.' +
        ' The address must be updated to be valid or one of the address lines must be changed to contain "General Delivery"' +
        ' in order to proceed.  Please contact your customer service representative if you have any questions';
    } else {
      this.validatedAddress.country = this.validatedAddress?.country === 'US' ? 'USA' : this.validatedAddress.country;
    }
    this.addressValidationErrors = this.addressResolution.messages!.map(message => message.details).join('. ');
    if (!this.addressResolution.validAddress) {
      this.addressValidationErrors += '   ADDRESS ERRORS MAY RESULT IN SHIPMENT DELAYS.';
    }
  }

  useValidatedAddress(): void {
    this.dialogRef.close(true);
  }

  close(): void {
    this.dialogRef.close(false);
  }

  getCloseButtonText(): string {
    if (this.addressResolution.validAddress) {
      return 'Keep Entered Address';
    } else {
      return 'Cancel Update';
    }
  }

}
